import React from 'react';
import { number, array } from 'prop-types';

import Table from 'ps-components/Table/Table/Table';
import TableHeader from 'ps-components/Table/TableHeader/TableHeader';
import TableBody from 'ps-components/Table/TableBody/TableBody';
import TableInfoList from 'ps-components/TableInfoList/TableInfoList';
import Cell from 'ps-components/Table/Cell/Cell';
import Row from 'ps-components/Table/Row/Row';

import { payElement } from '../../propTypes';
import { getDisplayValue, getYoYChange } from './helpers';

import './PayElementAtTargetTable.scss';

class SinglePayElementAtTargetTable extends React.Component {
  static propTypes = {
    data: payElement,
    monetaryRounding: number,
    percentRounding: number,
    pricingData: array
  };

  displayBenchmarkYear = dataLabel => {
    const { pricingData } = this.props;
    return pricingData.some(row => parseInt(row.benchmarkYear) === parseInt(dataLabel) && row.isSlotted)
      ? `${dataLabel} (Slotted)`
      : dataLabel;
  };

  getTableColumns(data) {
    return [
      this.displayBenchmarkYear(data.prevPrevYear.label),
      this.displayBenchmarkYear(data.prevYear.label),
      this.displayBenchmarkYear(data.currentYear.label),
      `${data.prevPrevYear.label} - ${data.prevYear.label}`,
      `${data.prevYear.label} - ${data.currentYear.label}`
    ];
  }

  getTableRows(data) {
    const { monetaryRounding, percentRounding } = this.props;

    return [
      getDisplayValue(data.prevPrevYear.value, monetaryRounding),
      getDisplayValue(data.prevYear.value, monetaryRounding),
      getDisplayValue(data.currentYear.value, monetaryRounding),
      getYoYChange(data.prevPrevYear.value, data.prevYear.value, percentRounding),
      getYoYChange(data.prevYear.value, data.currentYear.value, percentRounding)
    ];
  }

  render() {
    const { data } = this.props;

    return (
      <TableInfoList
        tableClass="pay-elements-table single-pay-element"
        cellClass="pxl-text-xsmall pay-elements-table__header-cell"
        rowClass="pay-elements-table__header"
        bodyClass="pay-elements-table__tbody"
        headers={this.getTableColumns(data)}
        data={this.getTableRows(data)}
      />
    );
  }
}

export default SinglePayElementAtTargetTable;
